// APIS

// General
export const FEED = "web/feed";
export const COMPANY = "web/company";

// Categories
export const JOB_CATEGORIES_HOME = "get_job_categories_home";
export const JOB_CATEGORIES = "jobcategories";
export const GOVT_JOBS_HOME = `get_govt_job_list_home?limit=8&offset=0`;
export const FRESHERS_JOBS_HOME = `get_fresher_job_list_home?limit=8&offset=0`;
export const LATEST_JOBS_HOME = `get_latest_job_list_home?limit=8&offset=0`;
export const GOVT_JOBS_CATEGORIES = `jobcategories?govt=1`;
export const FRESHERS_JOBS_CATEGORIES = `jobcategories?govt=0`;
export const EXPLORE_JOBS_CATEGORIES = `jobcategories?govt=2`;
export const GET_TOP_JOB_LOCATIONS = "get_top_job_locations";

// Current Affairs
export const CURRENT_AFFAIRS = "get_current_affairs_web";
export const FEATURED_CURRENT_AFFAIRS = "get_featured_current_affairs";
export const CURRENT_AFFAIRS_DETAILS = "get_current_affairs_details";

// Jobs
export const GOVT_JOBS_LIST = "get_govt_job_list";
export const FRESHERS_JOBS_LIST = "get_fresher_job_list_home";
export const PRIVATE_JOBS_LIST = "get_private_job_list";
export const INTERNSHIP_LIST = "get_internship_list";
export const ENGINEER_JOBS_LIST = "get_engg_job_list_home";
export const MBA_JOBS_LIST = "get_mba_job_list_home";
export const JOB_DETAILS = "get_job_details_web";
export const EXPLORE_JOB = "get_jobs_by_qualification";
export const LOCATION_JOBS = "get_jobs_by_location";
export const JOBS = "v3/Jobs";

// Material
export const GET_STUDY_MATERIAL_WEB = "get_study_materials_web";
export const GET_PLACEMENT_PAPERS = "get_placement_papers";
export const GET_PLACEMENT_COMPANIES = "getPlacementCompanies";
export const GET_GK_ARCHIVES = "get_GK_archives";
export const GET_GK_CATEGORIES = "getGKCategories_v2";

// Feedback
export const ADD_FEEDBACK = "add_feedback";
export const CONNECT_CAMPUS = "connect_campus";

// Post your job
export const POST_YOUR_JOB = "post_your_job";
export const GET_USER_LOCATIONS = "getUserLocations";

// Subscribe news letter
export const SUBSCRIBE_NOW = "subscribe_now";

// Candidates
export const GET_CANDIDATE_LISTING = "getCandidateListing";
export const ADD_CANDIDATE_ANALYSIS = "add_candidate_analysis";
export const SUBSCRIBE_PREMIUM_MEMBERSHIP = "subscribe_premium_membership";

// APP ROUTING
export const CURRENT_AFFAIRS_APP = "current-affairs";
export const JOB_DETAILS_APP = "job-description";
export const EXPLORE_JOB_APP = "explore-job";

// ANALYSIS
export const WEB_USER = "web/WebUser";
export const ADD_JOB_ANALYSIS = "add_job_analysis";

// industry courses
export const GET_ALL_COURSES = "get_all_courses";

// LOGIN
export const USER = "v3/user";
export const LOGIN = "login";

// SIGNUP
export const SIGNUP = "signup";

//FORGOT PASSWORD
export const FORGOT = "forgot_password";

// CHANGE PASSWORD
export const CHANGE_PASSWORD = "change_password";

// TESTIMONAL
export const GET_TESTIMONALS = "get_testimonials";

//USER
export const GET_USER_PROFILE = "v3/UserEduProfile";
export const GET_USER_DETAILS = "v3/user/get_user_profile";
export const UPDATE_USER_PROFILE_V3 = "v3/user/update_profile";
export const UPDATE_USER_IMAGE = "v3/user/upload_profile_image";
export const UPDATE_USER_PROFILE = "updateUserProfile";
export const FETCH_EDUCATION_PROFILE = "fetch_education_profile";
export const GET_COURSES_LIST = "get_courses_list";
export const GET_COURSE_SPECIALIZATION_LIST = "get_course_spealization_list";
export const CREATE_EDUCATION_PROFILE = "create_education_profile";
export const UPDATE_EDUCATION_PROFILE = "update_education_profile";
export const UPLOAD_RESUME = "upload_resume";
export const DELETE_RESUME = "delete_resume";
export const GET_COLLEGES_LIST = "v1/Settings/get_colleges";
export const GET_USER_PREFFERED_LOCATIONS = "v1/settings/get_user_locations";
export const GET_LOCATIONS_LIST = "v1/Settings/get_locations";
export const UPDATE_CURRENT_LOCATION = "v1/settings/update_user_current_location";
export const UPDATE_USER_LOCATION = "v1/settings/update_user_location";
